import { isZsl } from '@/lib/utils';
import { buttonTemplate, colors } from '@/theme/lib';
import styled, { css } from 'styled-components';

export const StyledBackToButton = styled.button`
  ${buttonTemplate}
  position: absolute;
  top: calc(100% - 0px);
  z-index: 1;
  display: ${(props) => isZsl(props.theme.key) ? 'flex' : 'none'};
  padding: 1.125rem 1.75rem 1rem 1.75rem;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;

  border-radius: 0 0 2.5rem 2.5rem;
  border: 2px solid ${(props) => props.theme.colors.button.back.border};
  border-top: 0px;
  background-color: ${(props) => props.theme.colors.button.back.bg};

  span {
    color: ${(props) => props.theme.colors.button.back.text};
  }

  ${(props) => props.theme.key === 'zsl' ? css`
  svg {
    path {
      stroke: ${colors.white};
    }
  }
  ` : undefined}
  
  &:hover,
  &:focus,
  &:focus-visible {
    border-color: ${(props) => props.theme.colors.tertiary};
  }
`;
